// extracted by mini-css-extract-plugin
module.exports = {"subTitle":"CustomLabel_subTitle__2KT4V"};